var React = require('react');
var { createElement: h, useState } = React;

// Suggest a variable name from a field's dot-path: use the last segment, and for
// an array index ("contacts.0") fold in the parent ("contacts_0"). Falls back to
// "output" for the whole-output root row. Strips anything not name-safe.
function deriveVarNameFromPath(path) {
  var p = String(path || '').trim();
  if (!p) return 'output';
  var segs = p.split('.').filter(Boolean);
  var last = segs[segs.length - 1];
  if (/^\d+$/.test(last) && segs.length >= 2) last = segs[segs.length - 2] + '_' + last;
  return last.replace(/[^A-Za-z0-9_]/g, '') || 'output';
}

// Inline chooser shown beneath an output tree row — it expands in place (NOT a
// native popup or modal overlay, matching the app's inline-edit convention) and
// lets the user either set an existing variable or create a new one from the
// row's value. On confirm it calls onSetToVariable({ path, value, target }).
function SetToVariableForm(props) {
  var path = props.path || '';
  var value = props.value;
  var variableNames = Array.isArray(props.variableNames) ? props.variableNames : [];
  var onSetToVariable = props.onSetToVariable;
  var onClose = props.onClose;
  var indent = props.indent || 0;

  var [name, setName] = useState(function() { return deriveVarNameFromPath(path); });

  function close() { if (typeof onClose === 'function') onClose(); }

  function emit(kind, varName) {
    if (typeof onSetToVariable === 'function') {
      onSetToVariable({ path: path, value: value, target: { kind: kind, name: varName } });
    }
    close();
  }

  function confirmNew() {
    var trimmed = String(name || '').trim();
    if (trimmed) emit('new', trimmed);
  }

  return h('div', {
    className: 'jt-setvar-form',
    style: { marginLeft: (indent + 18) + 'px' },
    onMouseDown: function(e) { e.stopPropagation(); },
    onClick: function(e) { e.stopPropagation(); }
  },
    variableNames.length
      ? h('div', { className: 'jt-setvar-existing' },
          variableNames.map(function(vn) {
            return h('button', {
              key: vn,
              type: 'button',
              className: 'jt-setvar-existing-item',
              title: 'Set ' + vn,
              onClick: function() { emit('existing', vn); }
            },
              h('span', { className: 'jt-setvar-existing-dot' }),
              h('span', { className: 'jt-setvar-existing-name' }, vn)
            );
          })
        )
      : null,
    h('div', { className: 'jt-setvar-or' }, variableNames.length ? 'or create new' : 'New variable'),
    h('div', { className: 'jt-setvar-newrow' },
      h('input', {
        className: 'jt-setvar-input',
        value: name,
        autoFocus: true,
        spellCheck: false,
        placeholder: 'variable name',
        onChange: function(e) { setName(e.target.value); },
        onKeyDown: function(e) {
          if (e.key === 'Enter') { e.preventDefault(); confirmNew(); }
          else if (e.key === 'Escape') { e.preventDefault(); close(); }
        }
      }),
      h('button', { type: 'button', className: 'jt-setvar-confirm', onClick: confirmNew }, 'Set'),
      h('button', { type: 'button', className: 'jt-setvar-cancel', title: 'Cancel', onClick: close }, '×')
    )
  );
}

module.exports = SetToVariableForm;
